import { CategoryScale } from "chart.js";
import { isNumber } from 'lodash-es';
import { abbreviateNumber } from "src/app/shared/helpers";

export const fitText = (ctx: CanvasRenderingContext2D, value: string, size: number): string => {
  if (ctx.measureText(value).width <= size){
    return value
  } else {
    while (ctx.measureText(value).width > size) {
      value = value.slice(0, -1);
    }
    return value + '...';
  }
}

export function tickValueToAxisLabel(scale: CategoryScale, value:  number | string, postfix: string, useAbbreviation: boolean): string {
  const paddings = 20;
  const layoutPaddingLeft = scale.chart?.options?.layout?.padding['left'] || 0;
  const paddingLeft = scale.paddingLeft || 0;
  const maxWidth = scale.maxWidth - paddingLeft - paddings - layoutPaddingLeft;
  let strValue: string;

  if (isNumber(value)) {
    strValue = useAbbreviation
      ? abbreviateNumber(value as number)
      : scale.getLabelForValue(value as number);
  } else {
    strValue = value as string;
  }
  return fitText(scale.ctx, strValue + postfix, maxWidth < 0 ? 0 : maxWidth);
}
